import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';

import { endpoints } from '@/api/endpoints';
import { AuthButton } from '@/auth/AuthButton';
import { LangSwitch } from './LangSwitch';

export function TopBar() {
  const { t } = useTranslation();
  const health = useQuery({
    queryKey: ['health'],
    queryFn: () => endpoints.health(),
    refetchInterval: 30_000,
    retry: false,
  });
  const ok = health.isSuccess;

  return (
    <header className="sticky top-0 z-50 bg-surface border-b border-border">
      <div className="max-w-[1440px] mx-auto px-6 py-3 flex items-center gap-6">
        <Link to="/" className="inline-flex items-center gap-2">
          <span className="font-semibold text-[15px]">PanelForge</span>
        </Link>

        <nav className="flex items-center gap-1">
          <NavLink to="/manual" className={navCls}>{t('nav.manual')}</NavLink>
          {/* Hidden per request; route still available, link restorable.
          <NavLink to="/projects" className={navCls}>{t('nav.dashboard')}</NavLink>
          */}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <HealthDot ok={ok} loading={health.isLoading} error={health.isError} />
          <LangSwitch />
          <AuthButton />
        </div>
      </div>
    </header>
  );
}

const navCls = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-1.5 rounded-md text-[13px] transition-colors ${
    isActive ? 'bg-surface-3 text-ink font-medium' : 'text-ink-3 hover:bg-surface-3 hover:text-ink'
  }`;

function HealthDot({ ok, loading, error }: { ok: boolean; loading: boolean; error: boolean }) {
  const { t } = useTranslation();
  const title = loading ? t('health.checking') : error ? t('health.down') : t('health.ok');
  const cls = loading
    ? 'bg-ink-4 animate-pulse'
    : ok
      ? 'bg-success'
      : 'bg-danger';

  return (
    <span
      title={title}
      className={`inline-block h-2.5 w-2.5 rounded-full ${cls}`}
      aria-label={title}
    />
  );
}
